<template>
  <div class="wrapper">
    <f-navbar></f-navbar>
    <f-sidebar></f-sidebar>
    <div class="content-wrapper">
      <section
        class="content-header"
        :class="{ 'content-header--with-actions': !!$slots['header-actions'] }"
        v-if="!$route.meta.noPageTitle"
      >
        <h1>
          {{ pageHeading || $route.meta.title || $route.name.toUpperCase() }}
          <small>{{ $route.meta.description }}</small>
        </h1>
        <div v-if="$slots['header-actions']" class="content-header__actions">
          <slot name="header-actions"></slot>
        </div>
      </section>
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <action-messages></action-messages>
          </div>
        </div>
        <slot></slot>
      </section>
    </div>
    <f-footer></f-footer>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Sidebar from '@/components/Sidebar';

export default {
  name: 'wrapper',
  components: {
    'f-navbar': Navbar,
    'f-footer': Footer,
    'f-sidebar': Sidebar,
  },
  created() {
    const adminLTEScript = document.createElement('script');
    if (!this.adminLTEIsLoaded) {
      adminLTEScript.setAttribute('src', '/js/AdminLTE/app.min.js');
      document.body.appendChild(adminLTEScript);
      this.$store.commit('SET_ADMIN_LTE', true);
    }
  },
  computed: {
    ...mapGetters([
      'adminLTEIsLoaded',
    ]),
    ...mapState('app', ['pageHeading']),
  },
};
</script>

<style lang="scss" scoped>
// When a page supplies header actions, lay the title and the actions out on one
// line with the actions pushed to the right. Only applies when the slot is used,
// so pages without header actions are unaffected.
.content-header--with-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;

  h1 {
    margin: 0;
  }
}
.content-header__actions {
  margin-left: auto;
}
</style>
